import React, { Component } from 'react'
import { List, Map } from 'immutable'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getQueryParams } from 'app/modules/router/selectors'
import { withRouter } from 'react-router'
import { actions as presenceActions, selectors } from 'app/modules/presence'
import PresenceTable from './PresenceTable'
import InlineSvg from 'svg-inline-react'
import { makeHasGate } from 'app/modules/gates/selectors'
import { getClearbitRevealContext } from 'app/modules/enrichment/clearbit/selectors'
import { Button, NavigationHeader, Input, ToolTip, Icon } from '@driftt/tide-core-legacy'
import { ensureIsAdmin } from 'app/modules/access/helpers'
import PresenceSidesheet from './PresenceSidesheet'
import Subnav from '../shared/Subnav'
import { setFilters as cacheFilters, getFilters as getCachedFilters } from 'app/cache/live'
import { getHasLiveWithReach } from 'app/modules/presence/api'
import { orgId } from 'app/modules/org/selectors'

const playIcon = require('!svg-inline?removeTags=true!images/icons/play-icon.svg')
const pauseIcon = require('!svg-inline?removeTags=true!images/icons/pause-icon.svg')

import './style.styl'
import ACCESS from 'utils/Access'

const PRESENCE_INTERVAL = 20000

const liveViewScreenshot = require('images/live-view-preview.svg')
const BellIcon = require('!svg-inline?removeTags=true!images/svg/message-alert.svg')

const DEFAULT_PRESENCE_INTERVAL = 5000
const PRESENCE_INTERVAL_KEY = 'presence-live-view-interval'

const ActionsAdmin = () => (
  <div className="pr-gated-actions">
    <Button type="primary" href="/settings/billing">
      Upgrade Your Plan
    </Button>
    <Button type="subtle" href="https://help.drift.com/article/live-view/" target="_blank">
      Learn More
    </Button>
  </div>
)

const ActionsRep = () => (
  <div className="pr-gated-actions">
    <Button type="subtle" href="https://help.drift.com/article/live-view/" target="_blank">
      Learn More
    </Button>
  </div>
)

const PresenceNavigationTitle = ({ newLiveUsersCount }) => {
  return (
    <div className="presence-title-container">
      <div className="presence-title-div">
        Live View ({newLiveUsersCount} Online)
      </div>
      <ToolTip flow="down" render={() => <div className="presence-tool-tip-text">The Live view count is now more accurate!  If visitors are in a Drift conversation or are not actively viewing your site, they will n ot be included in the total number of online visitors in the Live view count displayed.</div>}>
        <Icon name="question" height={14} width={14} />
      </ToolTip>
    </div>
  )
}

class Presence extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedUser: null,
      user: null,
      filters: props.filters,
      pause: false,
      accountMatchError: null,
      usersWithMessageSent: new Set()
    }

    this.updateFilters = _.debounce(this.props.actions.setFilters, 100)
  }

  componentDidMount() {
    const cachedFilters = getCachedFilters()
    const defaultFilters = { anonymousVisitors: true }
    const filters = cachedFilters || defaultFilters

    this.props.actions.setNewFilters(Map({ ...this.props.query, ...filters }))
    this.getHasLiveViewWithReachCutover()
  }

  async getHasLiveViewWithReachCutover() {
    const { LIVE_VIEW_WITH_REACH_EVENTS } = await getHasLiveWithReach(this.props.orgId)
    const updatedAtValue = LIVE_VIEW_WITH_REACH_EVENTS ? 'now-15m' : 'now-120s'
    this.props.actions.setNewFilters(this.props.newFilters.set('updatedAt', updatedAtValue))
    this.props.actions.getPresenceStateOnInterval(PRESENCE_INTERVAL)
  }

  componentWillUnmount() {
    this.props.actions.setProcessAllUsers(false)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.hasProcessedUsers) {
      this.handleNoMatchAccount(nextProps)
    }
  }

  setSelectedUser = user => {
    this.setState({
      selectedUser: user
    })
  }

  pause = () => {
    this.setState({
      pause: true
    })
  }

  start = () => {
    this.setState({
      pause: false
    })
  }


  togglePause = () => {
    const newPauseState = !this.state.pause
    this.setState({
      pause: newPauseState
    })
  }

  setCustomInterval = ({ value }) => {
    this.props.actions.setCustomInterval(value)
    localStorage.setItem(PRESENCE_INTERVAL_KEY, value)
  }

  clearUserFromURI = () => {
    const { q } = this.props.query
    this.props.router.replace({
      pathname: window.location.pathname,
      query: { ...q },
      hash: window.location.hash
    })
  }

  handleNoMatchAccount = props => {
    const { user, account } = props.query
    if (!user) {return}

    const cleanErrorAndURI = () => {
      setTimeout(() => {
        this.clearUserFromURI()
        this.setState({ accountMatchError: null })
      }, 5000)
    }

    const showOpenUser = user
    const hasMatch = this.props.userByAnonId({ anonymousId: user })

    if (showOpenUser && !hasMatch) {
      this.setState(
        {
          accountMatchError: {
            user: showOpenUser,
            account: account
          }
        },
        cleanErrorAndURI
      )
    }
  }

  listenForSideBarClose = () => {
    this.setState(
      {
        selectedUser: null
      },
      this.clearUserFromURI
    )
  }

  listenForMessageSent = newUserId => {
    this.props.actions.messageSent(newUserId)
  }

  handleStartConversationClick = ({ user }) => {
    this.setState({
      startConversationModalOpen: true,
      user
    })
  }

  handleStartConversationModalClose = () => {
    this.setState({
      startConversationModalOpen: false,
      user: null
    })
  }

  handleShowCompanyInfo = () => {
    return {
      onShow: this.pause,
      onClose: this.start
    }
  }

  handleChangeFilters = e => {
    const q = e.target.value ? { q: e.target.value } : undefined
    const { q: _previousValue, ...rest } = this.props.query
    this.props.router.replace({
      pathname: window.location.pathname,
      query: { ...rest, ...q },
      hash: window.location.hash
    })

    const filters = List(e.target.value.split(', '))
    this.setState({ filters }, () => {
      this.updateFilters(filters)
    })
  }

  handleToggleFilterKnownUsers = () => {
    const newValue = !this.props.filterKnownUsers
    const { k: _previousValue, ...rest } = this.props.query
    const k = newValue ? { k: true } : undefined

    this.props.router.replace({
      pathname: window.location.pathname,
      query: { ...rest, ...k },
      hash: window.location.hash
    })

    this.props.actions.setFilterKnownUsers(newValue)
  }

  useNewFilters = () => {
    this.props.actions.cancelPresenceInterval()
    this.props.actions.getPresenceStateOnInterval(PRESENCE_INTERVAL)
  }

  handleShowAnonymousVisitorsChanged = value => {
    const anonymousVisitors = value ? value : undefined
    const q = { anonymousVisitors }

    cacheFilters(q)

    this.props.router.replace({
      pathname: window.location.pathname,
      query: { ...this.props.query, ...q },
      hash: window.location.hash
    })

    this.props.actions.setNewFilters(this.props.newFilters.set('anonymousVisitors', anonymousVisitors))

    this.useNewFilters()
  }

  handleShow100Visitors = value => {
    this.props.actions.setShowMore(!this.props.showMore)

    this.useNewFilters()
  }

  renderGated() {
    return (
      <div className="pr-gate">
        <div className="pr-gated-content">
          <h2>Reach out and connect with leads while they’re on your site.</h2>
          <h3>See who’s online, follow important leads, and chat live…</h3>
          <p>
            Book more demos and close deals faster by reaching out to the people while they’re on your website - not
            once they’ve left. Unlock the power to follow users, get a notification and start a conversation while
            they’re already here, live on your site.
          </p>
          <div className="pr-gated-content-plan-name">
            <p>
              Available in <a href="/settings/billing">Standard Plan</a>
            </p>
          </div>

          {ensureIsAdmin() ? <ActionsAdmin /> : <ActionsRep />}

          <iframe
            width="390"
            height="221"
            src="https://www.youtube.com/embed/I_1U0c9N-gE"
            frameBorder="0"
            allowFullScreen
          />
        </div>
        <img src={liveViewScreenshot} />
      </div>
    )
  }

  renderTable() {
    const { users, presenceLoading } = this.props
    const pauseVerb = this.state.pause ? 'Resume' : 'Pause'
    const statusIcon = this.state.pause ? playIcon : pauseIcon
    return (
      <section className="presence-table-outer">
        {!!this.state.selectedUser && (
          <PresenceSidesheet
            onClose={this.listenForSideBarClose}
            listenForMessageSent={this.listenForMessageSent}
            user={this.state.selectedUser}
            revealContext={this.props.revealContext}
          />
        )}
        <div className="presence-table-wrapper">
          <div className="pr-filter-bar">
            <div className="pr-filter-bar-checkboxes">
              <div className="pr-filter-checkbox-container">
                <Input
                  type="checkbox"
                  label="Show anonymous visitors"
                  onChange={this.handleShowAnonymousVisitorsChanged}
                  checked={this.props.newFilters.get('anonymousVisitors')}
                />
              </div>
              <div className="pr-filter-checkbox-container">
                <Input
                  type="checkbox"
                  label="Show up to 250 visitors"
                  onChange={this.handleShow100Visitors}
                  checked={this.props.showMore}
                />
              </div>
            </div>

            <button onClick={this.togglePause} className="drift-button drift-button-primary">
              <InlineSvg src={statusIcon} /> {`${pauseVerb} live feed`}
            </button>
          </div>

          <PresenceTable
            paused={this.state.pause}
            users={users}
            setPagination={this.props.actions.setPagination}
            userLoadCount={this.props.pagination.userLoadCount}
            setSelectedUser={this.setSelectedUser}
            handleStartConversationClick={this.handleStartConversationClick}
            companyInfoHandler={this.handleShowCompanyInfo()}
            presenceLoading={presenceLoading}
            hasReveal={this.props.hasReveal}
            hasLiveReveal={this.props.hasLiveReveal}
          />
        </div>
      </section>
    )
  }

  renderNoMatchError() {
    const { account } = this.props.query
    return (
      <div className="no-match-error">
        <p>Looks like {account} is no longer on your site 🙁 We’ll let you know the next time they come back.</p>
      </div>
    )
  }

  render() {
    const { accountMatchError } = this.state
    const { gates, presenceProblems, newLiveUsersCount } = this.props
    const gateOrRender = gates.has_live_view && !gates.disabled_account ? this.renderTable() : this.renderGated()
    const hasAudiencesGate = ACCESS.hasGates('AUDIENCE') && ACCESS.isAdmin()

    const nodes = [
      {
        label: 'All audiences',
        path: '/audiences',
        external: true,
        hide: !hasAudiencesGate
      },
      {
        label: 'Audience coverage',
        path: '/audiences/coverage/all',
        external: true,
        hide: !hasAudiencesGate
      },
      {
        label: 'CONTACTS',
        expanded: true,
        nodes: [
          {
            label: 'All contacts',
            path: '/contacts',
            external: true
          },
          {
            label: 'Contact segments',
            path: '/contacts/segments',
            external: true
          },
          {
            label: 'Import contacts',
            path: '/contacts/imports',
            external: true
          },
          {
            label: 'Settings',
            path: '/contacts/contact-settings',
            external: true
          }
        ]
      },
      {
        label: 'ACCOUNTS',
        expanded: true,
        hide: !ACCESS.isAdmin(),
        nodes: [
          {
            label: 'All accounts',
            path: '/accounts',
            external: true
          },
          {
            label: 'Account segments',
            path: '/accounts/segments',
            external: true
          },
          {
            label: 'Import accounts',
            path: '/accounts/imports',
            external: true
          }
        ]
      },
      {
        label: 'Live view',
        path: '/live'
      }
    ]

    return (
      <div className="page-presence-wrapper">
        <Subnav title="Visitors" open={true} nodes={nodes} />
        <div className="page-presence">
          {!!accountMatchError && this.renderNoMatchError()}
          <div className="page-presence-title">
            <NavigationHeader title={<PresenceNavigationTitle newLiveUsersCount={newLiveUsersCount}/>} />
          </div>
          {presenceProblems && gates.has_live_view && ( 
            <strong className="presence-problems">
              <InlineSvg src={BellIcon} />
              Sorry, it looks like we are experiencing some issues with live view right now. Please try again in a
              little while.
            </strong>
          )}
          {gateOrRender}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const users = selectors.getNewLiveUsers(state)
  const interval = parseInt(localStorage.getItem(PRESENCE_INTERVAL_KEY)) || DEFAULT_PRESENCE_INTERVAL
  const reveal = getClearbitRevealContext(state)

  return {
    users,
    newFilters: selectors.getNewFilters(state),
    newLiveUsersCount: selectors.getNewLiveUsersCount(state),
    newSorts: selectors.getNewSorts(state),
    showMore: selectors.getShowMore(state),
    filterKnownUsers: selectors.getFilterKnownUsers(state),
    pagination: selectors.getPagination(state),
    presenceProblems: selectors.getPresenceProblems(state),
    presenceLoading: selectors.getPresenceLoading(state),
    interval,
    query: getQueryParams(state).toJS(),
    hasProcessedUsers: selectors.getHasProcessedUsers(state),
    userByAnonId: props => selectors.getUserByAnonymousId(state, props),
    revealContext: reveal,
    hasReveal: makeHasGate('hasReveal')(state),
    hasLiveReveal: makeHasGate('has_live_reveal')(state),
    orgId: orgId(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        setNewSorts: presenceActions.setNewSorts,
        setNewFilters: presenceActions.setNewFilters,
        setShowMore: presenceActions.setShowMore,
        getPresenceStateOnInterval: presenceActions.getPresenceStateOnInterval,
        cancelPresenceInterval: presenceActions.cancelPresenceInterval,
        setFilters: presenceActions.setFilters,
        setFilterKnownUsers: presenceActions.setFilterKnownUsers,
        setPagination: presenceActions.setPagination,
        setProcessAllUsers: presenceActions.setProcessAllUsers,
        setCustomInterval: presenceActions.setCustomInterval,
        bootstrapUser: presenceActions.bootstrapUser,
        setPresenceLoading: presenceActions.setPresenceLoading,
        messageSent: presenceActions.messageSent
      },
      dispatch
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Presence))



// WEBPACK FOOTER //
// ./src/scripts/components/Presence/index.js